import React, { useContext } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { LocalContext } from 'context';
import { gridContainer, noPadding } from 'styles';

const Slots = ({ slots }) => {
  const { theme } = useContext(LocalContext);
  return (
    <>
      {slots.map((slot, i) => (
        <Slot key={i}>
          {slot.time && <Time theme={theme}>{slot.time}</Time>}
          <Stream theme={theme} colored>
            {slot.livestream}
          </Stream>
          {slot.speaker && (
            <Speaker theme={theme} dangerouslySetInnerHTML={{ __html: slot.speaker }} />
          )}
        </Slot>
      ))}
    </>
  );
};

const Slot = styled(motion.div)`
  ${gridContainer}
  margin: .5rem 0;
  margin-left: 0.5rem 0;
  ${noPadding};
  color: ${({ theme }) => theme.textColor};
  grid-row-gap: 0.625rem;
  @media (min-width: 768px) {
    grid-column: 1/7;
  }
  @media (min-width: 1150px) {
    margin: 0rem;

    grid-column: 1/13;
  }
  @media (min-width: 1600px) {
    grid-column: 1/13;
  }
`;

const Time = styled.div`
  grid-column: auto;
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.textColor};
  span {
    margin-right: 0.375rem;
  }
  @media (min-width: 1150px) {
    grid-column: 1/2;
  }
`;

const Speaker = styled.div`
  grid-column: 2/7;
  font-weight: 400;
  font-size: 1.25rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.textColor};
  @media (min-width: 1150px) {
    grid-column: 6/11;
  }
`;

const Stream = styled.div`
  grid-column: 2/7;
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 2rem;
  color: ${({ theme }) => theme.textColor};
  @media (min-width: 1150px) {
    grid-column: 2/6;
  }
`;

export default Slots;
